const broadcastOptions = Object.freeze({
  CUSTOM_SEGMENT: 0,
  EVERYONE_SEGMENT: 1,
  ROLLING_SEGMENT: 2
})

export { broadcastOptions }



// WEBPACK FOOTER //
// ./src/modules/campaign-manage/enum/BroadcastOptions.js